/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
import Vue from 'vue'
import {
  db,
  firebase,
  firebaseStorage,
} from '../../../firebase'

const numShards = 3

const actions = {
  incrementCounter: async (ctx, {
    ref, doc, col, uid,
  }) => {
    // Select a shard of the counter at random
    const today = Vue.moment().format('YYYY-MM-DD')
    const shardId = `${today}-${Math.floor(Math.random() * numShards).toString()}`
    const shardRef = ref.collection(doc).doc(shardId)
    // Update count
    // shardRef.update({ col: firebase.firestore.FieldValue.increment(1) }, { merge: true })

    return db.runTransaction(async transaction => transaction.get(shardRef).then(snapshot => {
      if (!snapshot.exists) {
        transaction.set(shardRef, { [col]: 1, uid, date: today })
      } else {
        transaction.update(shardRef, { [col]: firebase.firestore.FieldValue.increment(1) })
      }
    }))
  },
  getFirebaseImage: (ctx, params) => new Promise((resolve, reject) => {
    firebaseStorage.ref('public').child(params).getDownloadURL()
      .then(url => {
        resolve(url)
      })
      .catch(error => {
        reject(error)
      })
  }),
}

export default {
  actions,
}
